var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'core'], function($, _, _s, Backbone, core) {
  var DialogView;
  return DialogView = (function(_super) {

    __extends(DialogView, _super);

    function DialogView() {
      DialogView.__super__.constructor.apply(this, arguments);
    }

    DialogView.prototype.pageId = null;

    DialogView.prototype.className = 'dialog-wrapper';

    DialogView.prototype.initialize = function(options, params) {};

    DialogView.prototype.render = function(content) {
      var pageId;
      if (content == null) {
        content = '';
      }
      pageId = _s.underscored(this.pageId + '_widget');
      this.$el.append(content);
      $('.dialog-content').attr('id', pageId).html(this.$el);
      return this;
    };

    DialogView.prototype.selector = function() {
      return '#' + $('.dialog-content').attr('id');
    };

    return DialogView;

  })(Backbone.View);
});
